import { create } from 'zustand';
import { BoardContextProp, ChatAIContexts } from './types';

type ChatAIState = ChatAIContexts & {
  isChatOpen: boolean;
  setBoardContext: (boardContext: BoardContextProp) => void;
  toggleChat: (to: boolean) => void;
};

export const useChatAIContextState = create<ChatAIState>((set) => ({
  isChatOpen: false,
  boardContext: null,
  setBoardContext: (boardContext: BoardContextProp) => set({ boardContext }),
  toggleChat: (to: boolean) => set({ isChatOpen: to }),
}));
